<ion-card class="app-background ion-padding">
  <form [formGroup]="contactDetailsForm" (ngSubmit)="submitNewUser()">
    <ion-grid class="ion-padding">
      <ion-row class="ion-text-center">
        <ion-col size="12">
          <ion-label class="panel-header-text" color="dark">
            {{ 'register_createanaccount' | translate }}
          </ion-label>
          <p class="ion-margin-top" color="dark">
            {{ 'register_enterup' | translate }}
          </p>
        </ion-col>
      </ion-row>

      <ion-row class="ion-padding-top">
        <ion-col size="12">
          <ion-label class="panel-label-text"
            >{{ 'register_email' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            type="email"
            formControlName="email"
            [class.is-invalid]="
              formHelper.isFieldValidCss('email', isFormSubmitAttempted())
            "
            placeholder="email@example.com"
          >
          </ion-input>
        </ion-col>
      </ion-row>

      <ion-row class="ion-padding-top">
        <ion-col size="12">
          <ion-label class="panel-label-text"
            >{{ 'register_password' | translate }}*</ion-label
          >
          <ion-input
            fill="outline"
            type="password"
            formControlName="password"
            [class.is-invalid]="
              formHelper.isFieldValidCss('password', isFormSubmitAttempted())
            "
          >
            <ion-input-password-toggle slot="end"></ion-input-password-toggle>
          </ion-input>
        </ion-col>
      </ion-row>

      <ion-row class="ion-margin-top ion-align-items-center">
        <ion-col size="6">
          <ion-button fill="clear" (click)="goBack()">
            <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button
            type="submit"
            class="ion-float-right"
            color="primary"
            [disabled]="contactDetailsForm.invalid"
          >
            <small>{{ 'register_next' | translate }}</small>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-card>
